"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(index1, index2) {
    return ['SWAPDB', index1.toString(), index2.toString()];
}
exports.transformArguments = transformArguments;
